import InfoLine from '../components/InfoLine';
import Section from '../components/Section';

const SectionSkills = () => (
  <Section title="Compétences" odd>
    <InfoLine title="Développement">JavaScript, TypeScript, React, Node.js</InfoLine>
    <InfoLine title="Intégration">HTML, CSS / SCSS, Tailwind</InfoLine>
    <InfoLine title="Outils">Git, Vite, Webpack, Jest, Cypress</InfoLine>
    <InfoLine title="Softs">VSCode, Photoshop</InfoLine>
    <InfoLine title="IA">Copilot, Claude Code, ChatGPT</InfoLine>
    <InfoLine title="Méthodologies">Agile Scrum</InfoLine>

    <InfoLine className="mt-4 not-print:max-desktop:mt-0" title="Langues étrangères">
      Anglais (courant), roumain
    </InfoLine>
  </Section>
);

export default SectionSkills;
